function datePicker() {
  if (!window.jQuery || !$.datepicker) return;
  $.datepicker.setDefaults($.datepicker.regional["ja"]);
  // ↑このソースは日本語の対応が必要ない場合は不要です。
  $('input[id^="date"]').each(function () {
    var inputEl = this;
    $(inputEl).datepicker({
      minDate: +2,
      beforeShowDay: function (date) {
        if (typeof window.canSelectPreferredDate === "function") {
          var dateText = $.datepicker.formatDate("yy/mm/dd", date);
          if (!window.canSelectPreferredDate(inputEl, dateText)) {
            return [false, "is-duplicate-date", "選択済み"];
          }
        }
        return [true, ""];
      },
      onSelect: function () {
        inputEl.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
  });
}
datePicker();